import MainLayout from '@/layouts/MainLayout'
import AuthLayout from '@/layouts/AuthLayout'

export default [
    {
        path: '/',
        name: 'app',
        component: MainLayout,
        redirect: { name: 'main-map' },
        children: [
            {
                path: '',
                name: 'main-map',
                component: () => import('../views/map/IndexComponent'),
            },
        ],
    },
    {
        path: '/auth',
        name: 'auth',
        component: AuthLayout,
        redirect: { name: 'auth.login' },
        children: [
            {
                path: 'login',
                name: 'auth.login',
                component: () => import('../views/auth/LoginComponent'),
            },
        ],
    },
]
